var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-calc__holder"},[_c('div',{staticClass:"t-calc__block t-calc__block_trio"},[_c('div',{staticClass:"t-calc__description t-calc__description_important"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }